import Rating from "@/components/base/Rating";

interface Testimonial {
  id: string;
  name: string;
  role: string;
  rating: number;
  text: string;
}

export default function TestimonialsAndFaq({ testimonials }: { testimonials: Testimonial[] }) {
  return (
    <section className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
            <span className="h-1 w-1 rounded-full bg-primary-500"></span>
            Loved by the region
          </span>
          <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            What business owners and customers say
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            Real feedback from businesses growing with Mysore Yellow Pages and the customers who found
            them here.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <div className="mt-3">
                <Rating value={t.rating} />
              </div>
              <figcaption className="mt-4 border-t border-background-100 pt-3">
                <span className="block font-heading text-sm font-bold text-foreground-950">{t.name}</span>
                <span className="block text-xs text-foreground-500">{t.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}